const baseUrl = '/notifications';
export const notificationsRoutes = {
  notifications: "".concat(baseUrl),
  notificationsById: id => "".concat(baseUrl, "/").concat(id),
  publish: id => "".concat(baseUrl, "/").concat(id, "/publish"),
  unpublish: id => "".concat(baseUrl, "/").concat(id, "/unpublish"),
  pending: "".concat(baseUrl, "/pending"),
  acknowledgement: notificationId => "".concat(baseUrl, "/").concat(notificationId, "/acknowledgement"),
  view: notificationId => "".concat(baseUrl, "/").concat(notificationId, "/view")
};